"use client"

import { Home, Wallet, RefreshCw, User } from "lucide-react"
import { useNavigate } from 'react-router-dom';

export function MobileNav({ activeTab, setActiveTab }) {
  const tabs = [
    { id: "home", to: '/', labelDesktop: "Dashboard", label: "Home", icon: Home },
    { id: "exchange", to: '/my/p2p', labelDesktop: "P2P Exchange", label: "Exchange", icon: RefreshCw },
    { id: "wallet", to: '/referral/system', labelDesktop: "Referral", label: "Referral", icon: Wallet },
    { id: "profile", to: '/mine', labelDesktop: "Mine", label: "Mine", icon: User },
  ]
  
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-gray-900 to-black border-t border-purple-500/20 shadow-[0_-4px_20px_rgba(149,76,233,0.15)]">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => {
              setActiveTab(tab.id)
              navigate(tab.to)
            }}
            className={`flex flex-1 flex-col items-center py-3 transition-colors ${
              activeTab === tab.id ? "text-purple-400" : "text-gray-400 hover:text-purple-300"
            }`}
          >
            <tab.icon
              className={`h-6 w-6 ${activeTab === tab.id ? "filter drop-shadow-[0_0_8px_rgba(192,132,252,0.8)]" : ""}`}
            />
            <span className="mt-1 text-xs font-medium">{tab.label}</span>
            {activeTab === tab.id && (
              <span className="absolute bottom-0 h-1 w-12 rounded-t-full bg-gradient-to-r from-purple-500 to-cyan-400" />
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
